module.exports = __webpack_public_path__ + "static/detail-carousel-a1d81cee2b6d86a3990a03aa8ccc332c.svg";